<script setup>
import ContainerRoot from '@js/components/containers/ContainerRoot.vue';
import DialogModal from '@js/components/dialogs/DialogModal.vue';

const { title = 'Aide' } = defineProps({
    title: { type: String, required: false },
});
</script>

<template>
    <DialogModal size="medium">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title>
            {{ title }}
        </template>

        <template #content>
            <ContainerRoot>
                <div class="wysiwyg">
                    <h2>Afficher une variable</h2>

                    <pre v-pre>{{ $variable }}</pre>

                    <h2>Afficher une variable HTML</h2>

                    <pre v-pre>{!! $variable !!}</pre>

                    <h2>
                        Afficher une variable HTML avec les variables actuelles
                    </h2>

                    <pre v-pre>{!!! $variable !!!}</pre>

                    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <div>
                            <h2>Conditions</h2>

                            <pre v-pre>
@if (condition)
  {{ $variable1 }}
@elseif (condition)
  {{ $variable2 }}
@else
  {{ $variable3 }}
@endif</pre>
                        </div>

                        <div>
                            <h2>Boucles</h2>

                            <pre v-pre>
@for ($i = 0; $i < 10; $i++)
  {{ $i }}
@endfor</pre>

                            <pre v-pre>
@foreach ($variables as $variable)
  {{ $variable }}
@endforeach</pre>
                        </div>
                    </div>
                </div>
            </ContainerRoot>
        </template>
    </DialogModal>
</template>
